@if (anchor) {
  <a [id]="anchor"></a>
}

<form class="location-finder-form" kb-layout="grid" [formGroup]="form">
  <div kb-grid-item-columns="6" kb-layout="grid">
    <h3 kb-grid-item-columns="8" kb-heading class="filter-heading" [appEditorId]="editorIds?.headline">{{ attributes.headline }}</h3>
    @if (facets$ | async; as facets) {
      <kb-select
        kb-grid-item-columns="8"
        formControlName="country"
        [standalone]="true"
        i18n-ariaLabel="Location finder country select label@@516176798986294299" ariaLabel="Country/Region"
      >
        <kb-select-option selected><ng-template i18n="Location finder country select all option@@1280395286403294774">All countries/regions</ng-template></kb-select-option>
        @for (countryCode of facets.countryCode; track countryCode) {
          <kb-select-option [value]="countryCode.value">
            <ng-template>{{ countryCode.value | countryName:'combined' }}</ng-template>
          </kb-select-option>
        }
      </kb-select>
    } @else {
      <kb-progress-indicator [visible]="true"></kb-progress-indicator>
    }
    <kb-input
      kb-grid-item-columns="8"
      formControlName="query"
      [standalone]="true"
      [ariaLabel]="(googleMapsConsent.given$ | async) === true ? intl.queryLabel.withGoogleMapsConsent : intl.queryLabel.withoutGoogleMapsConsent"
      [placeholder]="(googleMapsConsent.given$ | async) === true ? intl.queryLabel.withGoogleMapsConsent : intl.queryLabel.withoutGoogleMapsConsent"
      type="search"
    >
      <kb-icon slot="trailer" [icon]="iconSearch" aria-hidden="true" icon-uppercase icon-center></kb-icon>
      <button slot="trailer" type="button"
        i18n-aria-label="Location finder locate button title@@1763285737027844110" aria-label="Your location"
        i18n-title="Location finder locate button title@@1763285737027844110" title="Your location"
        kb-icon [icon]="iconLocate" icon-uppercase icon-center
        (click)="setCurrentPosition()"
      ></button>
    </kb-input>
    @if (useDistanceSearch === true) {
      <kb-range
        kb-grid-item-columns="8"
        formControlName="radius"
        [max]="1000"
        [step]="1"
      >
        <ng-container i18n="Location finder radius input label@@1834459349046815332">Radius</ng-container>: <span i18n="Radius value label@@3080354637208135595" class="radius-value">{{ form.controls.radius.value }} km</span>
      </kb-range>
    }
  </div>
  @if (categories.length > 1) {
    <div kb-grid-item-columns="3" kb-layout="grid">
      <h3 kb-grid-item-columns="12" kb-heading class="filter-heading" i18n="location finder filter heading@@8829497237648100098">Filter</h3>
      <div
        kb-grid-item-columns="12"
        kb-layout="flex"
        formGroupName="categories"
      >
        @for (category of categories; track category) {
          <kb-checkbox kb-flex-item="full" [standalone]="true"
            [formControlName]="category"
          >
            <div class="category-icon" [style.background-color]="attributes.categories[category].colorHex"></div>
            {{ attributes.categories[category].displayName }}
          </kb-checkbox>
        }
      </div>
    </div>
  }
  @if (competencies.length > 1) {
    <div kb-grid-item-columns="3" kb-layout="grid">
      <h3 kb-grid-item-columns="12" kb-heading class="filter-heading" i18n="location finder competence heading@@1455565159905351378">Workshop Competence</h3>
      <div
        kb-grid-item-columns="12"
        kb-layout="flex"
        formGroupName="competencies"
      >
        @for (competence of competencies; track competence) {
          <kb-checkbox kb-flex-item="full" [standalone]="true"
            [formControlName]="competence"
          >
            {{ attributes.competencies[competence].displayName }}
          </kb-checkbox>
        }
      </div>
    </div>
  }
</form>

<div class="results" kb-layout="grid">
  <div class="results--map" kb-grid-item-columns="6">
    @if ((googleMapsConsent.given$ | async) !== true) {
      <img class="map--preview-image" src="assets/location-finder-map-preview.jpg" aria-hidden="true" loading="lazy">
      <app-user-consent-dialog [consent]="googleMapsConsent">
        <ng-container slot="title" i18n="google maps gdpr consent title@@4702039118271169489">Data transmission to Google</ng-container>
        <ng-container i18n="google maps gdpr consent body@@1673252454998935971">
          This map is embedded on our website via Google Maps.<br>
          Data is only transmitted to Google when you click on “Agree”.<br>
          Please refer to the <a kb-link href="https://policies.google.com/privacy" target="_blank">privacy policy of Google</a> for more details.
        </ng-container>
      </app-user-consent-dialog>
    } @else {
      <div class="google-maps-map" #googleMaps></div>
      <div #googleMapsFilterControl class="google-maps-filter-control">
        <kb-checkbox
          [ngModel]="filterToVisibleLocations"
          (ngModelChange)="filterToVisibleLocationsChanged($event)"
          [standalone]="true"
          on="background"
          i18n="Google maps filter visible results@@4639673447927622549"
        >Filter to visible area</kb-checkbox>
      </div>
    }
  </div>

  <div kb-grid-item-columns="6" class="results--list-container">
    <div class="meta-info" kb-layout="flex">
      <p kb-paragraph>
        @if (results$ | async; as results) {
          @if (results.numRows !== null) {
            <ng-container i18n="Location finder result count@@2416820177109743864">{{ results.numRows }} results found</ng-container>
          }
          @if (results.visibleNumRows !== null) {
            <ng-container i18n="Location finder result count visible@@552918695634967097">&nbsp;({{ results.visibleNumRows }} visible)</ng-container>
          }
        }
      </p>
      <form [formGroup]="form">
        <kb-select
          kb-flex-item="full"
          formControlName="sortField"
          [standalone]="true"
          on="background"
          i18n-ariaLabel="Location finder sort select label@@7699622144571229146" ariaLabel="Sorting"
        >
          @if (useDistanceSearch) {
            <kb-select-option [value]="distanceSortField.value"><ng-template>{{distanceSortField.label}}</ng-template></kb-select-option>
          }
          @for (sortField of sortFields; track sortField) {
            <kb-select-option [value]="sortField.value"><ng-template>{{sortField.label}}</ng-template></kb-select-option>
          }
        </kb-select>
      </form>
    </div>
    <cdk-virtual-scroll-viewport autosize>
      @if (locations$ | async; as locations) {
        <div *cdkVirtualFor="let location of locations; let first = first; trackBy:trackByLocation; let index = index"
          class="location"
          [class.selected]="(selectedLocation$ | async)?.id === location.id"
          [attr.index]="index"
        >
          @if (castToLocation(location)) {
            <button type="button" class="basic-info" kb-layout="flex" (click)="selectLocation(location)">
              <div>
                @if (location.locationType === LocationType.Physical) {
                  @if (location.network) {
                    <h4 kb-heading [style.color]="attributes.networks[location.network].colorHex" class="network">{{attributes.networks[location.network].displayName}}</h4>
                  }
                }
                <h3 kb-heading class="company">{{location.name}}</h3>
                @if (location.nameLocalLanguage) {
                  <h3 kb-heading class="company local-language">{{location.nameLocalLanguage}}</h3>
                }
                @if (location.locationType === LocationType.Physical) {
                  <app-address [address]="location.address"></app-address>
                  @if (location.competencies && location.competencies.length > 0) {
                    <ul class="competencies">
                      @for (competence of location.competencies; track competence) {
                        <li>
                          <kb-icon [icon]="iconCompetence" icon-uppercase icon-center></kb-icon>{{attributes.competencies[competence].displayName}}
                        </li>
                      }
                    </ul>
                  }
                }
                @if ((selectedLocation$ | async)?.id !== location.id) {
                  <div class="contact-information-button">
                    <ng-container i18n="Location finder contact information button@@2633153337671849554">Click here for contact information</ng-container>
                    &nbsp;
                    <kb-icon [icon]="iconMoreInformation"></kb-icon>
                  </div>
                }
              </div>
              <div class="meta">
                <div class="category-icon" [style.background-color]="attributes.categories[location.category].colorHex" [title]="attributes.categories[location.category].displayName"></div>
                @if (location.locationType === LocationType.Physical) {
                  <a
                    class="route-link"
                    kb-icon [icon]="iconRoute" icon-uppercase icon-center
                    [href]="getRouteLink(location)" target="_blank"
                    i18n-title="Location finder open route button title@@1671443367023970932" attr.title="Open route to {{ location.name }}"
                    i18n-aria-label="Location finder open route button title@@1671443367023970932" attr.aria-label="Open route to {{ location.name }}"
                  ></a>
                }
              </div>
            </button>
            @if ((selectedLocation$ | async)?.id === location.id && (location.details$ | async); as locationDetails) {
              <div class="details">
                <app-contact-details [contactDetails]="locationDetails"></app-contact-details>
                @if (locationDetails.contacts.length > 0) {
                  <h3 kb-heading i18n="Location finder contacts heading@@5945986349492910662">Contacts</h3>
                  @for (contact of locationDetails.contacts; track contact) {
                    <app-contact [showImage]="false" type="floating" [contact]="contact"></app-contact>
                  }
                }
              </div>
            }
          }
        </div>
      } @else {
        <kb-progress-indicator [visible]="true"></kb-progress-indicator>
      }
    </cdk-virtual-scroll-viewport>
  </div>
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
